import type { RegionMonitoringReport } from '@protector/entities/region/models';
import { getWindowEvents } from 'pages/timeline/timeline.service';
import type { ActionsObservable, StateObservable } from 'redux-observable';
import { ofType } from 'redux-observable';
import type { AppState } from 'redux/app-state';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import type { LoadDaysIndicators, LoadWindowIndicator } from './indicators.actions';
import {
  IndicatorsActionsTypes,
  LoadDaysIndicatorsFailure,
  LoadDaysIndicatorsSuccess,
  LoadWindowIndicatorFailure,
  LoadWindowIndicatorSuccess
} from './indicators.actions';
import type { WindowIndicators } from '@protector/entities/indicator/types';
import { getDaysIndicators } from './indicators.service';

export const handleLoadDaysIndicators = (
  action$: ActionsObservable<ReturnType<typeof LoadDaysIndicators>>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(IndicatorsActionsTypes.LOAD_DAYS_INDICATORS),
    map(action => action.payload),
    withLatestFrom(state$.pipe(map(state => state.uiState.global.systemFlags))),
    switchMap(([payload, flags]) => getDaysIndicators(payload, !!flags?.P40_25084_splitRequestDaysIndicators)),
    map(result => {
      return LoadDaysIndicatorsSuccess(result);
    }),
    catchError((error: string) => of(LoadDaysIndicatorsFailure(error)))
  );

export const handleLoadWindowIndicator = (
  action$: ActionsObservable<ReturnType<typeof LoadWindowIndicator>>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(IndicatorsActionsTypes.LOAD_WINDOW_INDICATOR),
    map(action => action.payload),
    withLatestFrom(state$.pipe(map(state => state.entities.indicators.windows))),
    mergeMap(([payload, windows]) => {
      if (windows?.[payload.propertyId]?.[payload.areaId]) {
        return of();
      }
      return getWindowEvents(payload.propertyId, payload.areaId, payload.season_ids, payload.start_date, payload.end_date).pipe(
        map(response => {
          if (!response.data) return;
          const dataReturn: WindowIndicators = {
            propertyId: payload.propertyId,
            areaId: payload.areaId,
            window: response.data as RegionMonitoringReport
          };
          return LoadWindowIndicatorSuccess(dataReturn);
        }),
        catchError(() => of(LoadWindowIndicatorFailure('Error loading events')))
      );
    })
  );
